import React, { FC } from "react";
import { Button, SmallLoader } from "../../components";
import { useAppDispatch, useAppSelector } from "../../store";
import appConfig from "../../util/appConfig";
import {
  geEigentuemerwechselFullSummary,
  updateAdminEigentuemerwechselItemStatusById,
} from "../../store/slices/eigentuemerwechsel";
import API from "../../api/api";

interface IMags {
  itemId: string;
}

const Mags: FC<IMags> = ({ itemId }) => {
  const dispatch = useAppDispatch();
  const { eigentuemerwechselItem } = useAppSelector(
    (state) => state.eigentuemerwechsel.admin,
  );

  if (!eigentuemerwechselItem) {
    return null;
  }

  // if (eigentuemerwechselItem && eigentuemerwechselItem?.status === "accepted") {
  //   return null;
  // }
  
  return (
    <div
      style={{
        // textAlign: "end",
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "30px",
        gap: "20px",
      }}
    >
      {/* <SmallLoader /> */}
      {["check"].includes(eigentuemerwechselItem?.status ?? "") ? (
        <Button
          text="Zu bearbeiten"
          width="200"
          isOutlined
          outlineColor={appConfig.secondaryColor || appConfig.mainColor}
          textColor={appConfig.secondaryColor || appConfig.mainColor}
          onClick={async () => {
            if (itemId) {
              await dispatch(
                updateAdminEigentuemerwechselItemStatusById({
                  id: itemId,
                  status: "inWork",
                }),
              );
            }
          }}
        />
      ) : null}
      {["inWork"].includes(eigentuemerwechselItem?.status ?? "") ? (
        <Button
          text="Fertig"
          width="200"
          backgroundColor={appConfig.mainColor}
          onClick={() => {
            if (itemId) {
              dispatch(
                updateAdminEigentuemerwechselItemStatusById({
                  id: itemId,
                  status: "accepted",
                  getPdf: async () => {
                    return await API.eigentuemerwechsel.get.geEigentuemerwechselFullSummary(
                      itemId,
                      `${eigentuemerwechselItem.objectId ? `${eigentuemerwechselItem.objectId}_` : ""}${eigentuemerwechselItem.ort}_${eigentuemerwechselItem.strasse}_${eigentuemerwechselItem.hausnr}${eigentuemerwechselItem.hausnrzusatz ? eigentuemerwechselItem.hausnrzusatz : ""}${eigentuemerwechselItem.hausnrto ? `_${eigentuemerwechselItem.hausnrto}` : ""}`,
                    );
                  },
                }),
              );
            }
          }}
        />
      ) : null}
      {!["accepted"].includes(eigentuemerwechselItem?.status ?? "") ? (
        <Button
          text="Stornieren"
          width="200"
          backgroundColor="white"
          isOutlined
          outlineColor={"red"}
          textColor={"red"}
          onClick={() => {
            if (itemId) {
              dispatch(
                updateAdminEigentuemerwechselItemStatusById({
                  id: itemId,
                  status: "declined",
                }),
              );
            }
          }}
        />
      ) : null}
      {["accepted"].includes(eigentuemerwechselItem?.status ?? "") ? (
        <Button
          text="PDF herunterladen"
          width="200"
          isOutlined
          outlineColor={appConfig.secondaryColor || appConfig.mainColor}
          textColor={appConfig.secondaryColor || appConfig.mainColor}
          onClick={async () => {
            if (itemId) {
              await dispatch(
                geEigentuemerwechselFullSummary({
                  id: itemId,
                  pdfName: `${eigentuemerwechselItem.objectId ? `${eigentuemerwechselItem.objectId}_` : ""}${eigentuemerwechselItem.ort}_${eigentuemerwechselItem.strasse}_${eigentuemerwechselItem.hausnr}${eigentuemerwechselItem.hausnrzusatz ? eigentuemerwechselItem.hausnrzusatz : ""}${eigentuemerwechselItem.hausnrto ? `_${eigentuemerwechselItem.hausnrto}` : ""}`,
                }),
              );
            }
          }}
        />
      ) : null}
    </div>
  );
};

export default Mags;
